<template>
  <div>
    <div class="home_shop">
      <div class="home_shopMain">
        <p>商品一覧</p>
        <div class="home_shop_item" v-for="item in goodsInfo" @click="todetial(item)">
          <img src="../../assets/images/home/renqi.png">
          <img :src="item.goods_img">
          <span>{{item.goods_name}}</span>
          <span>{{item.goods_brief}}</span>
          <span>{{item.gmodel}}</span>
          <span>¥{{item.shop_price.toLocaleString()}}（税込￥{{item.market_price.toLocaleString()}}）</span>
        </div>
        <div class="goodsPhone" v-for="item in goodsInfo" @click="todetial(item)">
          <div class="goodsPhoneImg">
            <img :src="item.goods_img">
          </div>
          <div class="goodsPhoneText">
            <span>{{item.goods_name}}</span>
            <span>{{item.goods_brief}}</span>
            <span>{{item.gmodel}}</span>
            <span>￥{{item.shop_price.toLocaleString()}}（税込￥{{item.market_price.toLocaleString()}}）</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    name: "",
    data(){
      return {
        msg: 'hello vue',
        goodsInfo: [
          {
            goods_id: 1,
            click_count: 1,
            gmodel: "60粒(1日2粒目安)",
            goods_brief: "からだの中から透明感のある毎日をサポート。美容成分を配合した、毎日のサプリメントです。",
            goods_decs: [
              {
                brand: "コラーゲン含有加工食品",
                standard: "17.4g（290ｍｇ×60粒）",
                expiration_data: "未開封3年",
                method: "1日２粒を目安に水またはぬるま湯でお召し上がりください。",
                raw_material: "コラーゲンペプチド（魚ゼラチン由来）、ハトムギ粉末、水溶性淡水真珠末、メロン抽出末（デキストリン、小麦たんぱく質(小麦を含む)、メロン抽出物）、インドキノキ抽出末（インドキノキ抽出物、デキストリン）、シトラス果実・ローズマリー葉エキス末/セルロース、ビタミンC、HPMC、ステアリン酸カルシウム、二酸化ケイ素、ビタミンB6、炭酸マグネシウム、安定剤（カルボキシメチルセルロースナトリウム）、グリセリン脂肪酸エステル",
                save: "直射日光、高温多湿な場所を避けて保存してくださいご 。",
                warn: "薬を服用中、通院中または妊娠中、授乳中の方は医師にご相談の上、お召し上がりください。"
              }
            ],
            goods_img: "http://hten.isdg.cn/index/home/goods/bxw.png",
            goods_name: "雪白丸",
            goods_sn: "4573121730584",
            goods_thumb: [
              {
                detail: "http://hten.isdg.cn/index/home/goods_detial/bxw_1.png",
                detail11: "http://hten.isdg.cn/index/home/goods_detial/mbw_11.png",
                detail12: "http://hten.isdg.cn/index/home/goods_detial/bxw_12.png"
              }
            ],
            goods_video: null,
            home_active_cat: 4,
            keyword: "雪白丸,美白,淡化色斑,皮肤弹性",
            limit_buy_max: 100,
            limit_buy_min: 1,
            market_price: 2980,
            original_img: null,
            seller_note: "特别好，多多买",
            shop_price: 3218
          },
          {
            "goods_id": 2,
            "click_count": 1,
            "gmodel": "100粒(1日10粒目安)",
            "goods_brief": "ディ－プチャージコラーゲン実感のヒミツ気軽にコラーゲンを生活に取り入れてみましょう。",
            "goods_decs": [
              {
                "brand": "コラーゲン含有加工食品",
                "standard": "31g（310ｍｇ×100粒）",
                "expiration_data": "未開封3年",
                "method": "1日10粒を目安に水またはぬるま湯でお召し上がりください。",
                "raw_material": "フィッシユコラーゲン（魚ゼラチン由来）、水溶性淡水真珠末、桜の花エキス末（デキストリン、桜の花抽出物）、燕の巣エキス末（デキストリン、燕の巣エキス）/微結晶セルロース、糊料（プルラン）、ショ糖脂肪酸エステル、ビタミンC、香料、甘味料（スクラロース）,",
                "save": "直射日光、高温多湿な場所を避けて保存してくださいご  。",
                "warn": "薬を服用中、通院中または妊娠中、授乳中の方は医師にご相談の上、お召し上がりください。"
              }
            ],
            "goods_img": "http://hten.isdg.cn/index/home/goods/mrb.png",
            "goods_name": "美潤宝",
            "goods_sn": "4573121730591",
            "goods_thumb": [
              {
                "detail": "http://hten.isdg.cn/index/home/goods_detial/mrb_1.png",
                "detail11": "http://hten.isdg.cn/index/home/goods_detial/mrb_11.png",
                "detail12": "http://hten.isdg.cn/index/home/goods_detial/mrb_12.png"
              }
            ],
            "goods_video": null,
            "home_active_cat": 4,
            "keyword": "驻颜有术，抵抗糖化，美润宝",
            "limit_buy_max": 100,
            "limit_buy_min": 1,
            "market_price": 1380,
            "original_img": null,
            "seller_note": "哈哈哈",
            "shop_price": 1490
          },
          {
            goods_id: 6,
            click_count: 1,
            gmodel: "30粒(1日1粒目安)",
            goods_brief: "からだの中から透明感のある毎日をサポート。美容成分を配合した、毎日のサプリメントです。",
            goods_decs: [
              {
                brand: "乳酸菌含有加工食品",
                standard: "9g（300ｍｇ×30粒）",
                expiration_data: "未開封3年",
                method: "還元麦芽糖水飴、澱粉、乳酸菌末（マルトデキストリン、乳酸菌凍結乾燥末）、ビフィズス菌末（澱粉、ビフィズス菌乾燥殺菌乳酸菌原末）、殺菌乳酸菌末（殺菌乳酸菌、デキストリン）、殺菌ビフィズス菌末（殺菌ビフィズス菌、デキストリン）/結晶セルロース、ステアリン酸カルシウム、微粒二酸化ケイ素、安定剤（グアーガム）、（一部に乳成分を含む）。",
                raw_material: "1日1粒を目安に水またはぬるま湯でお召し上がりください,",
                save: "直射日光、高温多湿な場所を避けて保存してくださいご 。",
                warn: "薬を服用中、通院中または妊娠中、授乳中の方は医師にご相談の上、お召し上がりください。"
              }
            ],
            goods_img: "http://hten.isdg.cn/index/home/goods/yjb.png",
            goods_name: "益菌宝",
            goods_sn: "4573121730638",
            goods_thumb: [
              {
                detail: "http://hten.isdg.cn/index/home/goods_detial/yjb_1.png",
                detail11: "http://hten.isdg.cn/index/home/goods_detial/yjb_11.png",
                detail12: "http://hten.isdg.cn/index/home/goods_detial/yjb_12.png"
              }
            ],
            goods_video: null,
            home_active_cat: 4,
            keyword: "调节肠道功能,保持身体通畅",
            limit_buy_max: 100,
            limit_buy_min: 1,
            market_price: 2380,
            original_img: null,
            seller_note: "",
            shop_price: 2570
          },
          {
            goods_id: 3,
            click_count: 1,
            gmodel: "120粒(1日4粒目安)",
            goods_brief: "ゆっくり溶けて高い持続力キレイに嬉しい栄養を補う",
            goods_decs: [
              {
                brand: "ルテイン含有加工食品",
                standard: "36g（300ｍｇ×120粒）",
                expiration_data: "未開封3年",
                method: "デキストリン/ビタミンC、セルロース、HPMC、ステアリン酸カルシウム、二酸化ケイ素、ビタミンB2。",
                raw_material: "1日4粒を目安に水またはぬるま湯でお召し上がりください。",
                save: "直射日光、高温多湿な場所を避けて保存してくださいご  。",
                warn: "薬を服用中、通院中または妊娠中、授乳中の方は医師にご相談の上、お召し上がりください。"
              }
            ],
            goods_img: "http://hten.isdg.cn/index/home/goods/VC.png",
            goods_name: "ビタミンC",
            goods_sn: "4573121730607",
            goods_thumb: [
              {
                detail: "http://hten.isdg.cn/index/home/goods_detial/VC_1.png",
                detail11: "http://hten.isdg.cn/index/home/goods_detial/VC_11.png",
                detail12: "http://hten.isdg.cn/index/home/goods_detial/VC_12.png"
              }
            ],
            goods_video: null,
            home_active_cat: 3,
            keyword: "持续吸收,美容颜颜,改善气色,提高免疫力",
            limit_buy_max: 100,
            limit_buy_min: 1,
            market_price: 1980,
            original_img: null,
            seller_note: "对对都",
            shop_price: 2138
          },
          {
            goods_id: 4,
            click_count: 1,
            gmodel: "60粒(1日2粒目安)",
            goods_brief: "ゆっくり溶けて高い持続力ビタミンB群を8種類しっかり",
            goods_decs: [
              {
                brand: "ルテイン含有加工食品",
                standard: "15g（250ｍｇ×60粒）",
                expiration_data: "未開封3年",
                method: "デキストリン/セルロース、ナイアシン、V.B12、HPMC、パントテン酸カルシウム、V.B1、V.B6、V.B2、ステアリン酸カルシウム、二酸化ケイ素、ビオチン、葉酸。",
                raw_material: "1日2粒を目安に水またはぬるま湯でお召し上がりください。",
                save: "直射日光、高温多湿な場所を避けて保存してくださいご  。",
                warn: "薬を服用中、通院中または妊娠中、授乳中の方は医師にご相談の上、お召し上がりください。"
              }
            ],
            goods_img: "http://hten.isdg.cn/index/home/goods/VB.png",
            goods_name: "ビタミンB",
            goods_sn: "4573121730645",
            goods_thumb: [
              {
                detail: "http://hten.isdg.cn/index/home/goods_detial/VB_1.png",
                detail11: "http://hten.isdg.cn/index/home/goods_detial/VB_11.png",
                detail12: "http://hten.isdg.cn/index/home/goods_detial/VB_12.png"
              }
            ],
            goods_video: null,
            home_active_cat: 3,
            keyword: "持续吸收,减压抗疲劳,维持身体能量代谢",
            limit_buy_max: 100,
            limit_buy_min: 1,
            market_price: 2080,
            original_img: null,
            seller_note: "帝都",
            shop_price: 2246
          },
          {
            goods_id: 5,
            click_count: 1,
            gmodel: "60粒(1日3粒目安)",
            goods_brief: "からだの中から透明感のある毎日をサポート。美容成分を配合した、毎日のサプリメントです。",
            goods_decs: [
              {
                brand: "ルテイン含有加工食品",
                standard: "18g（300ｍｇ×60粒）",
                expiration_data: "未開封3年",
                method: "サフラワー油、マリーゴールドエキス［植物油（ひまわり油、オリーブ油）、マリーゴールド抽出物］、ビルべりーエキス末、菊花エキス末、カシスエキス末/ゼラチン、グリセリン、マリーゴールド色素、ミツロウ、カロテン色素。",
                raw_material: "1日3粒を目安に水またはぬるま湯でお召し上がりください。",
                save: "直射日光、高温多湿な場所を避けて保存してくださいご  。",
                warn: "薬を服用中、通院中または妊娠中、授乳中の方は医師にご相談の上、お召し上がりください。"
              }
            ],
            goods_img: "http://hten.isdg.cn/index/home/goods/mhy.png",
            goods_name: "目活源",
            goods_sn: "4573121730621",
            goods_thumb: [
              {
                detail: "http://hten.isdg.cn/index/home/goods_detial/mhy_1.png",
                detail11: "http://hten.isdg.cn/index/home/goods_detial/mhy_11.png",
                detail12: "http://hten.isdg.cn/index/home/goods_detial/mhy_12.png"
              }
            ],
            goods_video: null,
            home_active_cat: 3,
            keyword: "视力大救星,缓解眼疲劳,预防各种用眼过度引发眼部不适",
            limit_buy_max: 100,
            limit_buy_min: 1,
            market_price: 2180,
            original_img: null,
            seller_note: null,
            shop_price: 2354
          }
        ]
      }
    },
    methods: {
      todetial: function (item) {
        console.log(item);
        this.$router.push({path: "/goods_detial"})
        localStorage.setItem("goodsDetail", JSON.stringify(item))
      }
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  $textcolor1: #595758;
  $textcolor2: #595758;
  $textcolor3: #a0a0a0;
  $textcolor4: #f4a294;
  $colorlist: (
    1:$textcolor1,
    2:$textcolor2,
    3:$textcolor3,
    4:$textcolor4,
  );
  /*pc端字体大小*/
  $textsize1: 22px;
  $textsize2: 12px;
  $textsize3: 16px;
  $textsize4: 18px;
  $sizelist: (
    1:$textsize1,
    2:$textsize2,
    3:$textsize3,
    4:$textsize4,
  );
  /*手机字体大小*/
  $Ptextsize1: 15/$default-w+rem;
  $Ptextsize2: 12/$default-w+rem;
  $Ptextsize3: 13/$default-w+rem;
  $Ptextsize4: 14/$default-w+rem;
  $Psizelist: (
    1:$Ptextsize1,
    2:$Ptextsize2,
    3:$Ptextsize3,
    4:$Ptextsize4,
  );

  @each $i, $color in $colorlist {
    .home_shop_item span:nth-child(#{$i+2}) {
      color: $color;
    }
    .goodsPhoneText span:nth-child(#{$i}) {
      color: $color;
    }
  }

  @each $i, $size in $Psizelist {
    .goodsPhoneText span:nth-child(#{$i}) {
      font-size: $size;
    }
  }

  /*手机字体大小*/
  @each $i, $size in $Psizelist {
    .goodsPhoneText span:nth-child(#{$i}) {
      font-size: $size;
    }
  }

  $width: 100%;
  $flex: flex;
  $justify: space-around;
  $block: inline-block;

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .home_shop {
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      align-content: space-around;
      p {
        margin: 15/$default-w+rem 0;
        width: $width;
        text-align: center;
        font-size: 16/$default-w+rem;
      }
      .home_shop_item {
        display: none;
      }
      .goodsPhone {
        width: 100%;
        margin: 10px auto;
        padding: 0 2%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        .goodsPhoneImg {
          height: 3.4rem;
          width: 30%;
          img {
            height: 100%;
            width: 100%;
            padding: 4%;
            box-sizing: border-box;
          }
        }
        .goodsPhoneText {
          width: 70%;
          padding: 0 1%;
          box-sizing: border-box;
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          span {
            display: inline-block;
            width: 100%;
            text-align: center;
            margin-top: 0.15rem;
          }
          span:nth-child(2) {
            text-align: left;
            height: 1.2rem;
            line-height: 0.4rem;
          }
        }
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .home_shop {
      width: 100%;
      background-color: #f8f8f8;
      .home_shopMain {
        font-family: A-OTF 新丸ゴ Pro R;
        width: 750px;
        margin: 0 auto;
        background-color: #f8f8f8;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 40px;
        align-content: space-around;
        p {
          margin: 70px 0 50px 0;
          width: $width;
          text-align: center;
          font-size: 25px;
        }
        .home_shop_item {
          cursor: pointer;
          float: left;
          width: 200px;
          margin: 30px auto;
          img:nth-child(1) {
            width: 50px;
            height: 30px;
            margin-left: 15%;
          }
          img:nth-child(2) {
            width: 200px;
            height: 231px;
          }
          span {
            display: inline-block;
            width: $width;
            text-align: center;
            margin-top: 5px;
          }
          span:nth-child(4) {
            display: inline-block;
            height: 55px;
            width: 100%;
            margin-top: 10px;
            font-size: 13px;
            letter-spacing: 1px;
            /*background-color: red;*/
          }
        }
        .goodsPhone {
          display: none;
        }
      }
    }
  }

  @media screen and(min-width: $max-screen) {
    .home_shop {
      width: 100%;
      background-color: #f8f8f8;
      .home_shopMain {
        font-family: A-OTF 新丸ゴ Pro R;
        width: 1024px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 40px;
        align-content: space-around;
        p {
          margin: 70px 0 50px 0;
          width: $width;
          text-align: center;
          font-size: 25px;
        }
        .home_shop_item {
          float: left;
          width: 260px;
          margin: 30px auto;
          img:nth-child(1) {
            width: 50px;
            height: 30px;
            margin-left: 15%;
          }
          img:nth-child(2) {
            width: 260px;
            height: 300px;
          }
          span {
            display: inline-block;
            width: $width;
            text-align: center;
            margin-top: 5px;
          }
        }
        .goodsPhone {
          display: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/goods/goods.vue